// TODO: Fix eslint errors.
/* eslint-disable sonarjs/prefer-object-literal */
/* eslint-disable sonarjs/cognitive-complexity */
/* eslint-disable write-good-comments/write-good-comments */
/* eslint-disable array-callback-return */
/* eslint-disable no-plusplus */
/* eslint-disable guard-for-in */
/* eslint-disable no-restricted-syntax */

import React from 'react';
import searchParamsStringify from '@Utils/searchParamsStringify';
import UIBreadcrumbs from '@UI/Breadcrumbs';

function Breadcrumbs({
  breadcrumbs, currentRoute, searchParams, pageType,
}) {
  const baseUrl = currentRoute && currentRoute.path ? currentRoute.path.replace(':searchParams*', '') : null;
  let breadcrumbList = [];
  if (breadcrumbs && breadcrumbs.items !== undefined) {
    breadcrumbs.items.map((breadcrumb) => {
      if (breadcrumb.link !== null) {
        breadcrumbList.push({
          title: breadcrumb.title,
          url: breadcrumb.link,
        });
      } else {
        breadcrumbList.push({
          title: breadcrumb.title,
        });
      }
    });
  } else {
    return null;
  }
  const breadcrumbItems = {
    categories: {
      nullValues: [
        'page',
        'query',
      ],
    },
    tags: {
      nullValues: [
        'page',
        'query',
      ],
    },
  };
  if (searchParams && searchParams.facets) {
    for (const facetType in searchParams.facets) {
      const facets = searchParams.facets[facetType];
      let count = 0;
      let facetBreadcrumbs = [];
      for (const facet in facets) {
        if (facets[facet].checked && count < 1) {
          const facetBuilder = {};
          facetBuilder.facets = {};
          facetBuilder.facets[facetType] = { ...facets };
          breadcrumbItems[facetType].nullValues.forEach((facetName) => {
            facetBuilder[facetName] = null;
          });
          const url = `${baseUrl}${searchParamsStringify(pageType, facetBuilder)}`;

          facetBreadcrumbs.push({
            title: facets[facet].name,
            url,
          });
          count++;
        } else if (facets[facet].checked && count >= 1) {
          facetBreadcrumbs = [];
          break;
        }
      }
      breadcrumbList = [...breadcrumbList, ...facetBreadcrumbs];
    }
  }

  // Set last item to be highlighted.
  if (breadcrumbList.length > 1 && breadcrumbList[breadcrumbList.length - 1]) {
    breadcrumbList[breadcrumbList.length - 1].active = true;
  }

  // Setup mobile item.
  let mobileItem = breadcrumbList[breadcrumbList.length - 1];
  if (breadcrumbList.length > 1) {
    mobileItem = breadcrumbList[breadcrumbList.length - 2];
  }

  return (
    <UIBreadcrumbs items={breadcrumbList} mobileItem={mobileItem} />
  );
}

export default Breadcrumbs;
